module.exports = __webpack_public_path__ + "img/barilla-placeholder.svg?77f6092c84f688444b194389fd5a9c5e";